var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bto-sb-element"},[_c('div',{staticClass:"bto-sb-event-horse"},_vm._l((_vm.HRraces),function(items,idx){return _c('antepost-race',_vm._g({key:idx,attrs:{"items":items}},_vm.$listeners))}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }